import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.Porcelain,
    minHeight: "calc(100vh - 85px)",
    marginTop: "85px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "45px",
  },
  container: {
    backgroundColor: theme.colors.White,
    padding: "60px 90px",
    boxShadow: "0px 2px 15px #D0CFDB99",
    borderRadius: "15px",
    textAlign: "center",
    maxWidth: "600px",
    "& .title": {
      color: theme.colors.Violet,
      fontSize: "28px",
      fontFamily: theme.fontFamily.MARKPROBOLD,
      marginBottom: "20px",
    },
    "& .message": {
      color: theme.colors.Violet,
      fontSize: "16px",
      fontFamily: theme.fontFamily.MARKPRO,
      marginBottom: "30px",
      lineHeight: "1.6",
    },
    "& .status": {
      color: theme.colors.DodgerBlue,
      fontSize: "18px",
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      marginBottom: "20px",
    },
  },
}));

function VendorStatus({ status }) {
  const classes = useStyles();

  const getStatusMessage = () => {
    if (status === "pending") {
      return {
        title: "Account Pending Approval",
        message:
          "Your merchant account is currently pending approval. You will receive an email notification once your account has been reviewed and approved by our team.",
        statusText: "Status: Pending",
      };
    } else if (status === "rejected") {
      return {
        title: "Account Not Approved",
        message:
          "Unfortunately, your merchant account application was not approved. Please contact support for more information about this decision.",
        statusText: "Status: Rejected",
      };
    }
    return {
      title: "Account Status",
      message: "Please contact support for assistance.",
      statusText: "Status: Unknown",
    };
  };

  const statusInfo = getStatusMessage();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className="title">{statusInfo.title}</div>
        <div className="status">{statusInfo.statusText}</div>
        <div className="message">{statusInfo.message}</div>
      </div>
    </div>
  );
}

export default VendorStatus;

